import { CreditCardAdd, ApiCreditCardAdd } from "Types"

export const formatCard = (model: CreditCardAdd): ApiCreditCardAdd => {
  return  {
    cardNumber: model.number.replace(/\s/g, ''),
    cardHolderName: model.name,
    cardExpirationMonth: model.expirationMonth,
    cardExpirationYear: model.expirationYear,
    cardCvv: model.cvv,
    isMain: model.isMain,
  }
}

export default {
  formatCard
}